import * as types from "../actions/types";


const initialState = {
  list: [],
  total: 0,
  loading: false,
  card: null,
  lookups: {
    groups: [],
    rooms: [],
    responsible: [],
    edizm: [],
    equiptype: [],
    status: [],
  },
  filters: {
    responsible: [],
    rooms: [],
  },
  files: [],
};


export default function equipment(state = initialState, action) {
  switch (action.type) {

    case types.SET_EQUIPMENT_LIST:
      return {
        ...state,
        list: action.payload.items,
        total: action.payload.total,
      };

    case types.SET_EQUIPMENT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.SET_EQUIPMENT_CARD:
      return {
        ...state,
        card: action.payload,
      };

    case types.SET_EQUIPMENT_LOOKUPS:
      return {
        ...state,
        lookups: action.payload,
      };

    case types.SET_EQUIPMENT_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case types.SET_EQUIPMENT_FILES:
      return {
        ...state,
        files: action.payload,
      };

    default:
      return state;
  }
}
